<template>
<div style="width: 100%">
	<v-subheader>{{$t('landlords.landlords')}}</v-subheader>
	<v-tooltip top slot="activator">
		<v-btn
			:loading="isLoadingCreateLandlord"
			slot="activator"
			@click="addLandlord"
			color="indigo lighten-3"
			dark
			fab
		>
			<v-icon>add</v-icon>
		</v-btn>
		<span>{{$t('landlords.add_landlord')}}</span>
	</v-tooltip>
	<v-card style="width: 100%">
		<v-card-title>
			{{$t('landlords.landlords')}}
			<v-spacer />
			<v-text-field
				v-model="search"
				append-icon="search"
				:label="$t('workers.search')"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="landlords"
			:pagination.sync="pagination"
			:loading="loading"
			:total-items="totalItems"
			:rows-per-page-items="rowsPerPageItems"
		>
			<template slot="headers" slot-scope="props">
				<tr>
					<th
						v-for="header in props.headers"
						:key="header.text"
						:class="['table-head-column column sortable text-xs-' +
							(header.align ? header.align : 'left'),
							pagination.descending ? 'desc' : 'asc',
							header.value === pagination.sortBy ? 'active' : '']"
						@click="changeSort(header.value, header.sortable)"
					>
						<v-icon small v-if="header.sortable">arrow_upward</v-icon>
						{{ header.text }}
					</th>
				</tr>
			</template>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.landlord_name }}</td>
				<td>{{ props.item.person_firstname }}</td>
				<td>{{ props.item.person_lastname }}</td>
				<td class="text-xs-right">
					<v-btn fab dark small color="indigo lighten-2" :to="'/landlords/' + props.item.id">
						<v-icon dark>edit</v-icon>
					</v-btn>
				</td>
			</template>
			<v-alert slot="no-results" :value="true" color="error" icon="warning">
				{{$t('common.no_result', {search})}}
			</v-alert>
		</v-data-table>
	</v-card>
</div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { TEMPLATE_LANDLORD, HEADERS_TABLE_LANDLORDS } from '../constants'

import { localeHeadersWorkers } from "../utils/helpers";

export default {
	data(vm) {
		return {
			search: '',
			pagination: {
				page: 1,
				rowsPerPage: 25,
				sortBy: 'id',
				descending: 'asc'
			},
			totalItems: 0,
			rowsPerPageItems: [25, 50, 100, 200],
			headers: localeHeadersWorkers(HEADERS_TABLE_LANDLORDS, vm.$t)
		}
	},
	created() {
		this.search = this.$route.query.search ? this.$route.query.search : ''
		this.pushQuery(this.$route.query)
	},
	filters: {
		address_format(value) {
			var result = []
			for (let address of value) {
				result.push(address.street)
			}
			return result.join(', ')
		}
	},
	computed: {
		...mapState({
			isLoadingCreateLandlord: ({ landlords }) =>
				landlords.isLoadingCreateLandlord,
			meta: ({ landlords }) => landlords.meta,
			loading: ({ landlords }) => landlords.loading
		}),
		landlords() {
			return this.$store.state.landlords.list
		}
	},
	destroyed() {
		this.setList({
			data: []
		})
	},
	methods: {
		...mapActions({
			createLandlord: 'landlords/createLandlord',
			getListLandlords: 'landlords/fetch'
		}),
		...mapMutations({
			setList: 'landlords/setList'
		}),
		addLandlord() {
			this.createLandlord({ ...TEMPLATE_LANDLORD })
		},
		changeSort (column, sortable) {
			if(!sortable) {
				return
			}
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending
			} else {
				this.pagination.sortBy = column
				this.pagination.descending = false
			}
		},
		updatePagination() {
			this.getListLandlords(this.$route.query)
				.then(() => {
					this.totalItems = this.meta ? this.meta.total : null
				})
		},
		pushQuery (old_query = null) {
			let query = {
				count: this.pagination.rowsPerPage.toString(),
				offset: (this.pagination.rowsPerPage * (this.pagination.page - 1)).toString(),
				sortBy: this.pagination.sortBy,
				descending: this.pagination.descending ? 'asc' : 'desc'
			}
			this.search ? query.search = this.search.toLowerCase() : '',
			this.$router.push({ query: query })
			if(JSON.stringify(old_query) == JSON.stringify(query)) {
				this.updatePagination()
			}
		}
	},
	watch: {
		'pagination.page' () {
			this.pushQuery()
		},
		'pagination.rowsPerPage' () {
			this.pushQuery()
		},
		'pagination.descending' () {
			this.pushQuery()
		},
		'$route.query'() {
			this.updatePagination()
		},
		search () {
			this.pushQuery()
		}
	}
}
</script>
